/*
 * Copyright (C) 2024 - present Cohota, Inc.
 *
 * This file is part of Cohota.
 */
import clickCallback from './clickCallback';
import formatMessage from '../../../format-message';
import tinymce from 'tinymce'; // @ts-ignore

import { IconAddMediaLine } from '@instructure/ui-icons/es/svg'; // Register plugin

tinymce.PluginManager.add('catbus_media_embed', function (ed) {
  ed.ui.registry.addIcon('attach-media', IconAddMediaLine.src);
  ed.addCommand('catbusMediaEmbed', () => clickCallback(ed, document)); // Register menu item

  ed.ui.registry.addMenuItem('catbus_media_embed', {
    text: formatMessage('Media Embed'),
    icon: 'attach-media',
    onAction: () => ed.execCommand('catbusMediaEmbed')
  }); // Register toolbar button

  ed.ui.registry.addButton('catbus_media_embed', {
    tooltip: formatMessage('Media Embed'),
    icon: 'attach-media',
    onAction: () => ed.execCommand('catbusMediaEmbed')
  });
});